import { render, staticRenderFns } from "./PgaSaveButton.vue?vue&type=template&id=770dcf2a&"
import script from "./PgaSaveButton.vue?vue&type=script&lang=ts&"
export * from "./PgaSaveButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770dcf2a')) {
      api.createRecord('770dcf2a', component.options)
    } else {
      api.reload('770dcf2a', component.options)
    }
    module.hot.accept("./PgaSaveButton.vue?vue&type=template&id=770dcf2a&", function () {
      api.rerender('770dcf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaSaveButton.vue"
export default component.exports